import React from "react";

export default function Center({ children, style, ...props }) {
  return (
    <div {...props} style={{ display: "grid", placeItems: "center", ...style }}>
      {children}
    </div>
  );
}
